import React from "react";
import { useLocalization } from "../hooks/useLocalization";

export const LanguageSwitcher = ({ className = "" }) => {
  const { language, setLanguage } = useLocalization();

  return (
    <div className={`inline-flex items-center rounded-full border border-gray-200 bg-gray-50 p-1 ${className}`} data-testid="language-switcher">
      <button
        data-testid="language-switch-en"
        onClick={() => setLanguage("en")}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
          language === "en" ? "bg-blue-600 text-white shadow-sm" : "text-gray-500 hover:text-gray-800"
        }`}
      >
        EN
      </button>
      <button
        data-testid="language-switch-ja"
        onClick={() => setLanguage("ja")}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
          language === "ja" ? "bg-blue-600 text-white shadow-sm" : "text-gray-500 hover:text-gray-800"
        }`}
      >
        日本語
      </button>
    </div>
  );
};
